import { z } from 'zod';
import {
    mockSnapshot,
    Snapshot,
    snapshotSchema,
} from 'app/agriculture/queries/snapshots/types/Snapshot';

export interface FirmwareSnapshot extends Snapshot {
    packageName: string | null;
    packageUri: string | null;
    packageVersion: string | null;

    state: number | null;
    updateDeliveryMethod: number | null;
    updateResult: number | null;
}

export const firmwareSnapshotSchema = snapshotSchema.extend({
    packageName: z.string().nullable(),
    packageUri: z.string().nullable(),
    packageVersion: z.string().nullable(),

    state: z.number().nullable(),
    updateDeliveryMethod: z.number().nullable(),
    updateResult: z.number().nullable(),
});

export const mockFirmwareSnapshot = ({
    packageName = 'package name',
    packageVersion = 'package version',
    packageUri = 'package-uri',

    state = 0,
    updateDeliveryMethod = 1,
    updateResult = 2,

    ...snapshot
}: Partial<FirmwareSnapshot> = {}): FirmwareSnapshot => ({
    ...mockSnapshot(snapshot),

    packageName,
    packageVersion,
    packageUri,

    state,
    updateDeliveryMethod,
    updateResult,
});
